import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { confirm } from "lib/@dialogs/confirm"
import { isPublishedId } from "library/id-helpers"
import { parentFind } from "library/tree"
import { PlanRoot } from "library/tree/constants"
import Iconify from "minimals-template/components/Iconify"
import { useParams } from "react-router"

export function TailoringInReviewButton() {
    const { id } = useParams()
    const { editExtension, parentItem, payload, isRegimeDraftLocked } = useBoundContext()
    const isInRegime = parentFind(parentItem, (c) => c[PlanRoot])

    const show = !isPublishedId(id) && !!isInRegime && !!payload && !editExtension && isRegimeDraftLocked

    return (
        <If truthy={show}>
            <Button
                onClick={open}
                size="small"
                variant="outlined"
                color="primary"
                startIcon={<Iconify icon="ic:round-lock" />}
                data-cy="tailor-in-review-button"
            >
                In Review
            </Button>
        </If>
    )

    function open() {
        confirm("This schedule is being reviewed and can't be tailored right now.", "Schedule Locked")
    }
}
